import { ICCCItem } from 'types/ccc';

export const sortByPriority = (arr: ICCCItem[] = []) => {
    if (!arr) return [];
    const newArr = [...arr];
    const priority = { 'ccc-plus': 1, 'ccc-essential': 2, 'ccc-basic': 3 };

    return newArr.sort((a, b) => priority[a.skuCode] - priority[b.skuCode]);
};
